import { inject as service } from '@ember/service';
import { scheduleOnce } from '@ember/runloop';
import Route from '@ember/routing/route';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

export default Route.extend({
  router: service(),
  store: service(),

  model(params) {
    let mcController = this.controllerFor('messageCenter');
    let routeName = this.get('routeName');
    let parent = 'message-center.archive';

    let store = this.get('store');
    let threadId = params.threadId;

    //Sanitize threadId (with trim) and redirect if no match
    let sanitized = threadId.trim();

    if(threadId !== sanitized) {
      this.get('router').replaceWith(routeName, sanitized);
    }

    let model = {threadId: params.threadId, mcController: mcController};
    let thread = store.peekRecord('thread', threadId);

    if(thread && thread.get('archivedAt')) {
      return model;
    } else if(thread) {
      this.get('router').replaceWith(parent);
    } else {
      return store.findRecord('thread', threadId, {include:'messages,users,users.company,all-time-users,applications,assignment'}).then(returnedThread => {
        if(returnedThread) {

          mcController._initializeThreadStatuses(returnedThread);

          if(returnedThread.get('archivedAt')) {
            return model;
          } else {
            this.get('router').replaceWith(parent);
          }

          // return model;
        } else {
          // Process error message
          this.get('router').replaceWith(parent);
        }
      }, failReason => {
        this.get('router').replaceWith(parent);
      });
    }
  },
  setupController(controller, model) {
    this._super(controller, model);

    let mcController = model.mcController;
    if(model.threadId) {
      mcController.set('routeSegment', {threadId: model.threadId, view: 'archive'});
    } else {
      mcController.set('routeSegment', {threadId: null, view: 'archive'});
    }
  },
  activate(transition) {
    this._super(...arguments);
    trackPageViewFromTransition(this, transition, '/messages/archive/:threadId/');
  },
  actions: {
    didTransition() {
      let mcController = this.controllerFor('messageCenter');
      let model = this.controller.get('model');

      if(model.threadId) {
        mcController.set('routeSegment', {threadId: model.threadId, view: 'archive'});
      } else {
        mcController.set('routeSegment', {threadId: null, view: 'archive'});
      }

      scheduleOnce('afterRender', this, function() {
        mcController.get('_DOM_afterTransitionSetup')();
      });
    }
  }
});
